'use client'

import { type ComponentPropsWithoutRef, type FC, useId } from 'react'

import { type GkAirRecommendedProductWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import { useRecommendationWidgetContext } from '../RecommendationAreaProvider'

type RecommendationItemWithUdpTrackingProps = ComponentPropsWithoutRef<'li'> & {
  position: number
  product: GkAirRecommendedProductWeb
}

export const RecommendationItemWithUdpTracking: FC<
  RecommendationItemWithUdpTrackingProps
> = ({ children, position, product, ...listItemProps }) => {
  const trackingKey = useId()
  const { trackUdpProductImpression } = useRecommendationWidgetContext()

  return (
    <li
      ref={trackUdpProductImpression?.({
        position,
        product,
        trackingKey,
      })}
      {...listItemProps}
    >
      {children}
    </li>
  )
}
